import Vue from "vue";
import Vuex from "vuex";
import API from "../api";
Vue.use(Vuex);
let Store = null;
export default function () {
  Store = new Vuex.Store({
    state: {
      prestamoCalculado: null,
      ahorroCalculado: null,
      parametrosCoac: null,
      parametrosCoacAhorros: null,
      isLoading: false,
    },
    mutations: {
      SET_PRESTAMO_CALCULADO(state, prestamoCalculado) {
        state.prestamoCalculado = prestamoCalculado;
      },
      RESET_PRESTAMO_CALCULADO(state) {
        state.prestamoCalculado = null;
      },
      RESET_AHORRO_CALCULADO(state) {
        state.ahorroCalculado = {};
        state.ahorroCalculado = null;
      },
      SET_PARAMETROS_COAC(state, parametrosCoac) {
        state.parametrosCoac = parametrosCoac;
      },
      SET_PARAMETROS_COAC_AHORROS(state, parametrosCoacAhorros) {
        state.parametrosCoacAhorros = parametrosCoacAhorros;
      },
      SET_IS_LOADING(state, isLoading) {
        state.isLoading = isLoading;
      },
      SET_AHORRO_CALCULADO(state, ahorroCalculado) {
        state.ahorroCalculado = ahorroCalculado;
      },
    },
    actions: {
      async setAhorroCalculado(
        { commit },
        { interes, plazo, cuotaAhorro, monto, tipoAhorro }
      ) {
        let ahorroCalculado = await API.calculoAhorros(
          interes,
          plazo,
          cuotaAhorro,
          monto,
          tipoAhorro
        );
        commit("SET_AHORRO_CALCULADO", ahorroCalculado);
      },
      async setPrestamoCalculado(
        { commit },
        { capital, plazo, tipoCredito, tipoCuota }
      ) {
        let prestamoCalculado = await API.calculoPrestamo(
          capital,
          plazo,
          tipoCredito,
          tipoCuota
        );
        commit("SET_PRESTAMO_CALCULADO", prestamoCalculado);
      },
      resetPrestamoCalculado({ commit }) {
        commit("RESET_PRESTAMO_CALCULADO");
      },
      resetAhorroCalculado({ commit }) {
        commit("RESET_AHORRO_CALCULADO");
      },
      async setParametrosCoac({ commit }, coacId) {
        let parametrosCoac = await API.parametrosCoac(coacId);
        commit("SET_PARAMETROS_COAC", parametrosCoac);
      },
      async setParametrosCoacAhorros({ commit }, coacId) {
        let parametrosCoacAhorros = await API.parametrosCoacAhorros(coacId);
        commit("SET_PARAMETROS_COAC_AHORROS", parametrosCoacAhorros);
      },
      setIsLoading({ commit }, isLoading) {
        commit("SET_IS_LOADING", isLoading);
      },
    },
    getters: {
      getAhorroCalculado(state) {
        return state.ahorroCalculado;
      },
      getPrestamoCalculado(state) {
        return state.prestamoCalculado;
      },
      getParametrosCoac(state) {
        return state.parametrosCoac;
      },
      getParametrosCoacAhorros(state) {
        return state.parametrosCoacAhorros;
      },
      getIsLoading(state) {
        return state.isLoading;
      },
    },
    modules: {},
  });
  return Store;
}
export { Store };
